module.exports = __webpack_public_path__ + "img/cube-harvesting-robot.4cc100f7.png";